import { SVGProps } from "react";

const Logout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.75 15.375C12.6764 17.2269 11.1331 18.7994 9.06564 18.7488C8.58464 18.7371 7.99014 18.5694 6.80112 18.234C3.93961 17.4269 1.45555 16.0704 0.859556 13.0316C0.750001 12.473 0.750001 11.8444 0.750001 10.5873L0.750001 8.91274C0.750001 7.65561 0.750001 7.02704 0.859556 6.46845C1.45555 3.42963 3.93961 2.07314 6.80112 1.266C7.99014 0.930616 8.58465 0.762925 9.06564 0.751158C11.1331 0.70058 12.6764 2.27305 12.75 4.12499"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.75 9.75H18.75M7.75 9.75C7.75 9.04977 9.7443 7.74153 10.25 7.25M7.75 9.75C7.75 10.4502 9.7443 11.7585 10.25 12.25"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Logout;
